import { styled } from 'styled-components';

const ServiceSelectionPageStyled = styled.div`
    display: flex;
    flex-direction: row;
`;
export default ServiceSelectionPageStyled;
